export const mockVolunteerOpportunities = [
  {
    id: "1",
    title: "Education Program Coordinator",
    commitment: "Weekly",
    location: "Remote",
    category: "Education",
    description: "Help coordinate our girls education initiative — manage communications with partner schools, track student progress, and prepare reports.",
    skills: ["Communication", "Organization", "MS Office"],
    spots: 3,
  },
  {
    id: "2",
    title: "Pashto / Dari Translator",
    commitment: "Flexible",
    location: "Remote",
    category: "Language",
    description: "Translate documents, website content, and communications between English and Pashto or Dari to support our bilingual operations.",
    skills: ["Pashto or Dari", "English", "Attention to Detail"],
    spots: 5,
  },
  {
    id: "3",
    title: "Fundraising & Events Volunteer",
    commitment: "Monthly",
    location: "Toronto / Ottawa",
    category: "Fundraising",
    description: "Assist in planning and executing fundraising events, donor outreach campaigns, and community awareness activities across Canada.",
    skills: ["Event Planning", "Social Media", "Networking"],
    spots: 8,
  },
  {
    id: "4",
    title: "Social Media & Content Creator",
    commitment: "Weekly",
    location: "Remote",
    category: "Marketing",
    description: "Create engaging content for our social media channels, write blog posts, and help grow our online presence to reach more donors.",
    skills: ["Social Media", "Writing", "Graphic Design"],
    spots: 2,
  },
  {
    id: "5",
    title: "Medical Professional (Field)",
    commitment: "Seasonal",
    location: "Afghanistan (Field)",
    category: "Healthcare",
    description: "Join our mobile health clinic teams as a doctor, nurse, or paramedic. Provide primary care to underserved communities in rural Afghanistan.",
    skills: ["Medical License", "First Aid", "Cross-cultural Communication"],
    spots: 4,
  },
  {
    id: "6",
    title: "Grant Writing Specialist",
    commitment: "Flexible",
    location: "Remote",
    category: "Administration",
    description: "Research funding opportunities and write compelling grant proposals to secure financial support from Canadian and international foundations.",
    skills: ["Grant Writing", "Research", "English Writing"],
    spots: 2,
  },
];

export const mockTestimonials = [
  {
    id: "1",
    name: "Sarah Mitchell",
    role: "Education Coordinator Volunteer",
    duration: "2 years",
    quote: "Volunteering with CAF has been one of the most meaningful experiences of my life. Seeing the direct impact on girls\' education is incredibly rewarding.",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Canadian%20woman%20smiling%2C%20headshot%20portrait%2C%20warm%20natural%20lighting%2C%20clean%20background&width=100&height=100&seq=vol1&orientation=squarish",
  },
  {
    id: "2",
    name: "Ahmad Karimi",
    role: "Pashto Translator",
    duration: "3 years",
    quote: "As an Afghan-Canadian, contributing to CAF\'s mission feels like giving back to my roots. The team is passionate and the work truly matters.",
    avatar: "https://readdy.ai/api/search-image?query=Afghan%20Canadian%20man%20smiling%2C%20professional%20headshot%2C%20warm%20lighting%2C%20clean%20background&width=100&height=100&seq=vol2&orientation=squarish",
  },
  {
    id: "3",
    name: "Dr. Priya Sharma",
    role: "Medical Field Volunteer",
    duration: "1 year",
    quote: "The mobile health clinic program is life-changing. I treated patients who had never seen a doctor before. CAF makes the impossible possible.",
    avatar: "https://readdy.ai/api/search-image?query=South%20Asian%20female%20doctor%20smiling%2C%20professional%20portrait%2C%20warm%20lighting%2C%20clean%20background&width=100&height=100&seq=vol3&orientation=squarish",
  },
];